import { useState, useEffect } from "react";

/** Banner shown when the browser goes offline. Auto-dismisses when back online. */
export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[var(--color-warning)]/50 px-4 py-2 text-center text-sm font-medium text-yellow-950">
      You are offline. Some features may not work until you reconnect.
    </div>
  );
}
